const input_box = {
    namespaced: true,
    state: {
        visible: false,

        resolve: null,
        reject: null,

        title: null,
        fieldname: null,
        comment: "",
    },
    mutations: {
        SET_VISIBLE(state, payload) {
            state.visible = payload;
        },
        SET_TITLE(state, payload) {
            state.title = payload ?? "Укажите_причину";
        },
        SET_FIELDNAME(state, payload) {
            state.fieldname = payload ?? "Причина";
        },
        SET_COMMENT(state, payload){
            state.comment = payload;
        },
        SET_RESOLVE(state, payload) {
            state.resolve = payload;
        },
        SET_REJECT(state, payload) {
            state.reject = payload;
        },
    },
    actions: {
        async open({ commit }, { title, fieldname }) {
            commit('SET_TITLE', title);
            commit('SET_FIELDNAME', fieldname);
            commit('SET_COMMENT', "");

            commit('SET_VISIBLE', true);

            return new Promise((resolve, reject) => {
                commit('SET_RESOLVE', resolve);
                commit('SET_REJECT', reject);
            });
        },
        async ok({ commit, state }) {
            commit('SET_VISIBLE', false);
            state.resolve(state.comment);
        },
        async cancel({ commit, state }) {
            commit('SET_VISIBLE', false);
            state.reject({ message: "Cancelled" });
        },
    },
    getters: {
        isVisible: (s) => s.visible,
        getTitle: (s) => s.title,
        getFieldname: (s) => s.fieldname,
        getComment: (s) => s.comment
    }
}

export default input_box;